import { createAction, props } from '@ngrx/store';
import { InputParams, Locale } from '../models/common.model';
import { CommandQueryState } from '../models/common.store.model';

export enum GrowthReportSharedStoreActions {
  SetIsLoading = '[Growth Report] Set Is Loading',
  SetIsMultiStageReportLoading = '[Growth Report] Set Is Multi Stage Report Loading',
  SetLocale = '[Growth Report] Set Locale',
  SetCommandQuery = '[Growth Report] Set Command Query',
  ResetSharedStore = '[Growth Report] Reset Shared Store',
  SetInputParams = '[Growth Report] Set Input Params',
  SetShowSideNav = '[Growth Report] Set Show Side Nav',
}

export const ActionSetIsLoading = createAction(
  GrowthReportSharedStoreActions.SetIsLoading,
  props<{ isLoading: boolean }>(),
);

export const ActionSetIsMultiStageReportLoading = createAction(
  GrowthReportSharedStoreActions.SetIsMultiStageReportLoading,
  props<{ isMultiStageReportLoading: boolean }>(),
);

export const ActionSetLocale = createAction(GrowthReportSharedStoreActions.SetLocale, props<{ locale: Locale }>());

export const ActionSetCommandQuery = createAction(
  GrowthReportSharedStoreActions.SetCommandQuery,
  props<{ commandQuery: CommandQueryState }>(),
);

export const ActionSetInputParams = createAction(
  GrowthReportSharedStoreActions.SetInputParams,
  props<{ inputParams: InputParams }>(),
);

export const ActionSetShowSideNav = createAction(
  GrowthReportSharedStoreActions.SetShowSideNav,
  props<{ showSideNav: boolean }>(),
);

export const ActionResetSharedStore = createAction(GrowthReportSharedStoreActions.ResetSharedStore);
